<template>
   <ion-page id="lichess-connect-page">
    <ion-content >
 
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
            :style="styleConnect">
       <h2>{{  title }}</h2>
       <div v-html="message"></div>
    </div>
    </ion-content>
    <Toolbar :elements="toolbarElements" :trigger="toolbarTrigger" @toolbar-click="toolbarClick" />
  </ion-page>
</template>
  
  <script setup>
  
    import { IonItem,IonInput,IonPage, IonContent , modalController } from '@ionic/vue';

    import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
    import { t } from '@/composables/translateText.js'

    import { ref, watch } from 'vue'
    import Toolbar from '@/components/Toolbar.vue'
    import { useConnectionStore } from '@/stores/connectionStore';
    import { useWindowSizeStore } from '@/stores/windowSizeStore';
    import { doStartupCheck } from '@/composables/startupCheck.js'
    import { useGetData, getWebSiteURL } from '@/composables/getData.js'
    import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

    import { v4 as uuidv4 } from 'uuid';

    const emit = defineEmits(['next-item-click'])

    const connectionStore = useConnectionStore()
    
    const isDark = ref(connectionStore.getDarkmode != "light")
    const menuTrigger = ref(0)

    const windowSizeStore = useWindowSizeStore()
    const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

    var lichessUserid = ""
    var lichessVerifier = ""
    var lichessUUID = ""
    var lichessAccessToken = connectionStore.getLichessAccessToken

    const whichMenu = localStorage.getItem("whichMenu")
    const showBigButtons = ref(whichMenu == "buttons" || connectionStore.getShowBigButtons)
 
    const title = ref(t("Connect to Lichess"))
    const message = ref(t("Click 'Connect' to bring up a lichess.org screen where you'll tell Lichess that this program has permission to play using your Lichess account.<p>Note: when you 'Connect' it will say the request is coming from Chessvis and that's okay.<p>Click 'Refresh' after connecting to load the access token"))
  
    const TOOLBAR_CONNECT = 0
    const TOOLBAR_REFRESH = 1
    const TOOLBAR_DONE = 2
  
    const toolbarElements = ref([
      { index : TOOLBAR_CONNECT, label : t("Connect") ,disabled : true},
      { index : TOOLBAR_REFRESH, label : t("Refresh") ,disabled : true}
    ])

    if (whichMenu == "buttons")
      toolbarElements.value.push({ index : TOOLBAR_DONE, label : t("Done") , disabled : false})

    const toolbarTrigger = ref(0)
  
    const styleConnect = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })


    doStartupCheck(false,afterStartupCallbackRoutine)
  
    const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

    function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
      if (errorProgram != null)
        openErrorModal(errorProgram,errorEntry)
      lichessAccessToken = connectionStore.getLichessAccessToken
      if (lichessAccessToken != undefined && lichessAccessToken != "") {
        message.value = t("You are connected to Lichess<p>If the connection isn't working, try 'Disconnecting' and then 'Connecting' again")
      }
      else
        getLichessVerifer()
      menuTrigger.value++
      updateWidthHeights()
    }
  
    watch(() => windowSizeStore.getWindowSize, () => {
      windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
      menuTrigger.value++
      updateWidthHeights()
    })

    function updateStyleObjects(boundaries) {
    styleConnect.value.height = boundaries['connect'].height + "px"
    styleConnect.value.width = boundaries['connect'].width + "px"
    styleConnect.value.top = boundaries['connect'].top + "px"
    styleConnect.value.left = boundaries['connect'].left + "px"
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculateWidthHeights(availableSpace) :
                                      calculateWidthHeights(availableSpace)
    updateStyleObjects(boundaries)
  }

  function calculateWidthHeights(availableSpace) {

    const connectPositionTop = 0
    const connectPositionLeft = availableSpace.leftRightIndent 
    const connectHeight = availableSpace.height - connectPositionTop
    const connectWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { connect : {
        width : connectWidth,
        height : connectHeight,
        left : connectPositionLeft + availableSpace.leftIndent,
        top : connectPositionTop+ availableSpace.topIndent
      }

    }
    return (result)
  }


    function toolbarClick(arrayIndex) {
      switch (arrayIndex) {
        case TOOLBAR_DONE :
          emit("next-item-click","big_button_menu",t("Big Button Menu"),"buttons")
          break
        case TOOLBAR_CONNECT :
          connectToLichess();
          break;
        case TOOLBAR_REFRESH :
          doStartupCheck(true,afterStartupCallbackRoutine)
          break
      }
    }
  
    function connectToLichess() {
      // const urlRaw = "https://oauth.lichess.org/oauth/authorize?scope=board:play%20challenge:write%20tournament:write%20follow:read&redirect_uri=https://www.chessvis.com/lichess_callback.php&client_id=cZblLKMuqXbkgzTq&response_type=code&state=" +
      //               uuid
  
      const webURL = getWebSiteURL()
      const callbackProgram = (process.env.NODE_ENV === 'production') ? 
                                          "lichess_prod_callback.php" : "lichess_dev_callback.php"
      const responseType = "response_type=code"
      const clientId = "&client_id=verbalchess.fun"
      const redirectUri = "&redirect_uri=" + webURL + callbackProgram
      const codeChallengeMethod = "&code_challenge_method=S256"
      const codeChallenge = "&code_challenge=" + lichessVerifier
      const scope = "&scope=board:play%20challenge:write%20tournament:write%20follow:read"
      const state = "&state=" + lichessUUID
  
      const urlRaw = "https://lichess.org/oauth?" +
                  responseType + redirectUri + clientId + codeChallengeMethod + codeChallenge + scope + state
      
      //console.log("**** verifier before call",lichessVerifier)
      //console.log("URL ->",urlRaw)
  
      window.open(urlRaw)
    }
  

    function processJsonResponse (json) {
      //console.log(" in lichess verifer callback",json)
      if (json.hasOwnProperty('error')) {
        openErrorModal(json['programRun'],json['error'])
        return;
      }
      
      lichessVerifier = json['verifier']

      toolbarElements.value[TOOLBAR_CONNECT].disabled = false
      toolbarElements.value[TOOLBAR_REFRESH].disabled = false

    }

  function getLichessVerifer() {

    lichessUUID = uuidv4().replace(/-/g,"")

    var formData = {
      u : lichessUUID
    }
    
    useGetData("getweb_verbal_lichess_token.php", formData, processJsonResponse)
  }
  </script>
  
  <style scoped>
  
  #connect-selector-container {
    position : relative;
    border-style : solid;
    border-width: 2px;
    margin : 30px auto;
    padding : 15px 15px;
    line-height: 1.4em;
    width : 600px;
    height: calc(100vh - 125px);
    overflow-y: auto;
    font-family: "Nunito", sans-serif;   /* rounded */
    text-align: center;
  
  }
  
  </style>